export const unwrapEnvelope = (payload, fallback = null) => {
  if (payload?.success !== undefined && Object.prototype.hasOwnProperty.call(payload, "data")) {
    return payload.data ?? fallback;
  }

  if (payload?.data?.success !== undefined && Object.prototype.hasOwnProperty.call(payload.data, "data")) {
    return payload.data.data ?? fallback;
  }

  if (Object.prototype.hasOwnProperty.call(payload || {}, "data")) {
    return payload.data ?? fallback;
  }

  return payload ?? fallback;
};

export const unwrapList = (payload) => {
  const data = unwrapEnvelope(payload, []);

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.items)) return data.items;

  return [];
};

export const unwrapMeta = (payload, fallback = {}) => {
  if (payload?.success !== undefined && Object.prototype.hasOwnProperty.call(payload, "meta")) {
    return payload.meta ?? fallback;
  }

  if (payload?.data?.success !== undefined && Object.prototype.hasOwnProperty.call(payload.data, "meta")) {
    return payload.data.meta ?? fallback;
  }

  return payload?.meta || payload?.data?.meta || fallback;
};

export const toApiErrorMessage = (error, fallback = "Request failed") =>
  error?.message ||
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  fallback;
